// extracted by mini-css-extract-plugin
module.exports = {"button":"dece2e673c--button--1pkoD","icon":"dece2e673c--icon--3zA6j"};